import React, { memo } from 'react'
import { XIcon } from '@heroicons/react/solid'
import c from 'classnames'
import ReactModal from 'react-modal'
import Button from '../Button'

ReactModal.setAppElement('#app')

const baseClasses = [
  'modal-base outline-none align-bottom bg-white rounded-lg text-left shadow-xl transform transition-all sm:align-middle sm:w-full mx-4 my-auto border-radius-md pb-5'
]

const defaultClasses = ['sm:max-w-lg']
const smallClasses = ['sm:max-w-sm']
const bigClasses = ['sm:max-w-6xl']

const Modal = ({
  open = false,
  children,
  onSuccess = () => {},
  onCancel = () => {},
  onlyOk = false,
  closeOutside = true,
  autoClose = true,
  okMessage = 'Ok',
  cancelMessage = 'Cancel',
  closeIcon = true,
  zIndex = 100,
  noButtons = false,
  small = false,
  big = false,
  deleteOkButton = false,
  loadingOk = false,
  noOverlay = false,
  position = null,
  fullButtons = false,
  noPadding = false,
  disableOk= false,
  ...props
}) => {
  // Click ok
  const okClick = () => {
    if (onSuccess) {
      onSuccess()
    }
  }

  // Click cancel
  const cancelClick = () => {
    if (onCancel) {
      onCancel()
    }
  }

  const customStyles = {
    content: {
      zIndex
    },
    overlay: { zIndex: zIndex - 1 }
  }

  let sizeClass = defaultClasses

  if (small) {
    sizeClass = smallClasses
  } else if (big) {
    sizeClass = bigClasses
  }

  if (position !== null) {
    customStyles.content.position = 'absolute'

    if (position.top !== undefined) {
      customStyles.content.top = position.top
    }

    if (position.left !== undefined) {
      customStyles.content.left = position.left
    }

    if (position.right !== undefined) {
      customStyles.content.right = position.right
    }

    if (position.bottom !== undefined) {
      customStyles.content.bottom = position.bottom
    }
  }

  return (
    <ReactModal
      shouldCloseOnOverlayClick={closeOutside}
      overlayClassName={{
        base: c('fixed inset-0 flex justify-center items-start', !noOverlay && 'modal-overlay-base bg-gray-800 bg-opacity-90'),
        afterOpen: c('overflow-auto', !noOverlay && 'modal-overlay-after-open'),
        beforeClose: 'modal-overlay-before-close'
      }}
      onRequestClose={() => {
        if (autoClose) {
          cancelClick()
        }
      }}
      closeTimeoutMS={300}
      style={customStyles}
      isOpen={open}
      className={{
        base: [...baseClasses, ...sizeClass].join(' '),
        afterOpen: 'modal-after-open',
        beforeClose: 'modal-before-close'
      }}
      {...props}
    >
      <div className={c('pt-5 relative', !noButtons && 'pb-4 sm:pb-4', noButtons && 'sm:pb-0 pb-0', noPadding && 'px-0', !noPadding && 'px-4')}>
        {closeIcon && cancelClick && (
          <div className="absolute t-0.5 right-4">
            <XIcon className="w-7 h-7 text-gray-800 cursor-pointer" onClick={cancelClick}/>
          </div>
        )}
        <div className="sm:flex sm:items-start">{children}</div>
      </div>
      {!noButtons && (
        <div className="px-4 pt-3 sm:px-6">
          <>
            <Button
              extraStyle={fullButtons || small ? 'w-full' : ''}
              isDelete={deleteOkButton}
              isLoading={loadingOk}
              onClick={okClick}
              disabled={disableOk}
            >
              {okMessage}
            </Button>
            {!onlyOk && (
              <Button
                extraStyle={c('mt-2', (fullButtons || small) && 'w-full')}
                onClick={cancelClick}
                minimal={true}
              >
                {cancelMessage}
              </Button>
            )}
          </>
        </div>
      )}
    </ReactModal>
  )
}

export default memo(Modal)
